var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "icon-class": "mdi mdi-record",
          title: _vm.isEditMode
            ? _vm.$t(
                "pages.admin.livestream.announcements.add_or_update.title_edit"
              )
            : _vm.$t(
                "pages.admin.livestream.announcements.add_or_update.title_add"
              )
        }
      }),
      _vm._v(" "),
      _c("static-loading-indicator-icon", { attrs: { "with-card": true } }),
      _vm._v(" "),
      !_vm.$store.getters.shouldLoadLocal
        ? _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "language-switcher-nav",
                  {
                    attrs: { language: _vm.selectedLanguage },
                    on: {
                      "update:language": function($event) {
                        _vm.selectedLanguage = $event
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "title" } }, [
                          _c("strong", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.livestream.announcements.model.title"
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.title[_vm.selectedLanguage],
                              expression: "title[selectedLanguage]"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": _vm.$errors.has("title") },
                          attrs: {
                            type: "text",
                            id: "title",
                            placeholder: _vm.$t(
                              "pages.admin.livestream.announcements.model.title"
                            )
                          },
                          domProps: { value: _vm.title[_vm.selectedLanguage] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.title,
                                _vm.selectedLanguage,
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("error", {
                          attrs: { input: "title." + _vm.selectedLanguage }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mt-3" },
                      [
                        _c("label", { attrs: { for: "starts_at_date" } }, [
                          _c("strong", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.livestream.announcements.model.starts_at"
                                  )
                                ) +
                                "\n                                (" +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.livestream.announcements.model.date"
                                  )
                                ) +
                                ")\n                            "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.start_date,
                              expression: "start_date"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.$errors.has("start_date")
                          },
                          attrs: {
                            type: "date",
                            id: "starts_at_date",
                            placeholder: _vm.$t(
                              "pages.admin.livestream.announcements.model.starts_at"
                            )
                          },
                          domProps: { value: _vm.start_date },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.start_date = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("error", { attrs: { input: "start_date" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mt-3" },
                      [
                        _c("label", { attrs: { for: "starts_at_time" } }, [
                          _c("strong", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.livestream.announcements.model.starts_at"
                                  )
                                ) +
                                "\n                                (" +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.livestream.announcements.model.time"
                                  )
                                ) +
                                ")\n                            "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.start_time,
                              expression: "start_time"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.$errors.has("start_time")
                          },
                          attrs: {
                            type: "time",
                            id: "starts_at_time",
                            placeholder: _vm.$t(
                              "pages.admin.livestream.announcements.model.starts_at"
                            )
                          },
                          domProps: { value: _vm.start_time },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.start_time = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("error", { attrs: { input: "start_time" } })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.handleSave }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.isEditMode
                            ? _vm.$t("actions.update")
                            : _vm.$t("actions.create")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }